export default __webpack_public_path__ + "static/media/efilePin.07788328.png";